import {makeObservable, observable} from "mobx";

import {BaseWidgetDisplayModel} from "../../models/base-widget-display-model";

export class AppLineupsDisplayModel extends BaseWidgetDisplayModel {
  @observable isBoxScoresVisible: Boolean;

  constructor() {
    super();

    makeObservable(this);
  }
}
